// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"594":"c2feaa60","854":"c8b3855f"}[chunkId] + ".css";
};